import { acceptHMRUpdate, defineStore } from 'pinia';
import { computed, ref, watch } from 'vue';


export const useContextStore = defineStore('context', () => {
  // refs become state properties
  const scope = ref();
  const permissionMap = ref({});
  const user = ref({});
  const grants = ref([]);

  // computeds become getters
  const getScope = computed(() => scope.value);

  // const getScopeName = computed(() => {
  //   const scope = scope.value || sessionStorage.getItem('scope') || undefined;
  //   if (!scope) return;
  //   const permissionMap = permissionMap.value || JSON.parse(sessionStorage.getItem('permissionMap')) || undefined;
  //   if (!permissionMap) return;
  //   return permissionMap[scope.value]?.scope.name;
  // });

  // const getGrants = computed(() => permissionMap?.value?.[scope.value]);
  const getGrants = computed(()=> grants.value);

  watch(scope, (newScope) => {
    grants.value = permissionMap?.value?.[newScope];
  });

  const getUser = computed(() => user.value);

  const getPermissionMap = computed(() => permissionMap?.value);

  // const getScopePermission = computed(() => {
  //   const scope = scope.value || sessionStorage.getItem('scope') || undefined;
  //     if (!scope)
  //       return null;
  //   const permissionMap = getPermissionMap;
  //   if (!permissionMap.value)
  //     return null;
  //   return permissionMap[scope.value]?.grants;
  // });



  // functions () become actions

  function initContextFromStorage () {
    // if ew wanted 'remember me' functionality, use localStorage!
    const storedScope = sessionStorage.getItem('scope');
    if (storedScope)
      scope.value = storedScope;
    const storedPermissionMap = sessionStorage.getItem('permissionMap');
    if (storedPermissionMap)
      permissionMap.value = JSON.parse(storedPermissionMap);
    const storedUser = sessionStorage.getItem('user');
    if (storedUser)
      user.value = JSON.parse(storedUser);
    return this;
  }

  function setPermissionMap (toPermissionMap) {
    sessionStorage.setItem('permissionMap', JSON.stringify(toPermissionMap));
    permissionMap.value = toPermissionMap;
    return this;
  };

  function setScope (toScope) {
    sessionStorage.setItem('scope', toScope);
    scope.value = toScope;
    return this;
  }

  function setUser (toUser) {
    sessionStorage.setItem('user', JSON.stringify(toUser));
    user.value = toUser;
    return this;
  }


  // make sure to return everything!
  return {
    getGrants,
    getScope,
    getPermissionMap,
    getUser,
    initContextFromStorage,
    permissionMap,
    //getScopeName,
    setPermissionMap,
    //getScopePermission,
    scope,
    setScope,
    setUser,
    user,
  };
});


if (import.meta.webpackHot || import.meta.hot) {
  import.meta.hot?.accept(acceptHMRUpdate(useContextStore, import.meta.hot));
  import.meta.webpackHot?.accept(acceptHMRUpdate(useContextStore, import.meta.webpackHot));
};
